const dashboard = {
  dashboardTitle: 'لوحة التحكم',
  policiesTab: 'وثائق التأمين',
  sadadBillsTab: 'فواتير سداد',
  policyholderName: 'اسم حامل الوثيقة',
  purchaseDate: 'تاريخ الشراء',
  activationDate: 'تاريخ التٝعيل',
  expirationDate: 'تاريخ الانتهاء',
  actions: 'الإجراءات',
  printPolicy: 'طباعة الوثيقة',
  printReceipt: 'طباعة الإيصال',
  benefits: 'المزايا',
  billNumber: 'رقم الفاتورة',
  status: 'الحالة',
  amount: 'المبلغ',
  dueDate: 'تاريخ الاستحقاق',
  billerName: 'اسم المفوتر',
  billerCode: 'رمز المفوتر',
  policyAmount: 'مبلغ الوثيقة',
  billExpiryDate: 'تاريخ استحقاق الفاتورة',
  policyholderId: 'رقم هوية حامل الوثيقة',
  policyHolderFullName: 'الاسم الكامل لحامل الوثيقة',
  insuranceCompany: 'شركة التأمين',
  policyHolderName: 'إسم حامل الوثيقة',
  purchasedOn: 'تاريخ الشراء',
  policyInceptionDate: 'تاريخ تفعيل الوثيقة',
  policyExpiryDate: 'تاريخ إنتهاء الوثيقة',
  policyPurchaseDate: 'تاريخ شراء الوثيقة',
  policyStatus: 'حالة الوثيقة',
  printPolicyAction: 'طباعة الوثيقة',
  printReceiptAction: 'طباعة إيصال الدفع',
  earnedBenefits: 'المزايا المكتسبة',
  cancelPolicyHeader: 'طلب إلغاء التأمين و إسترداد المبلغ',
  cancelPolicyButton: 'طلب إلغاء التأمين و إسترداد المبلغ',
  close: 'اغلاق',
  noBenefitsAvailable: 'لا توجد مزايا متاحة حاليا',
  showDetails: 'عرض التفاصيل',
  coupon: 'كوبون',
  renewPolicyHeader: 'تجديد الوثيقة',
  renewPolicyButton: 'تجديد',
  noBillsFound: 'لا توجد فواتير متاحة حاليا',
  cancellationRequestSuccess:
    'تم تقديم طلب إلغاء الوثيقة بنجاح. يرجى توقع تواصل فريق شركة التأمين معك خلال 2 إلى 5 أيام عمل.',
  myRewardsTab: 'مكافآتي',
  currentBalance: 'عدد النقاط الحالي',
  totalAcrossAllTime: 'المجموع عبر كل الأوقات',
  referredCustomers: 'عدد العملاء المشاركين',
  points: 'نقاط',
  persons: 'أشخاص',
  earnings: 'المجمعة',
  redeemed: 'المٌسترَدة',
  acrossAllTime: 'عبر كل الأوقات',
  referAndEarn: 'ادعُ صديقًا واربح',
  referralDescription:
    'ستكسب 20 نقطة مقابل كل 1 ريال سعودي ينفقه صديقك المشارك على تأمين الأخطاء الطبية من تأميني.',
  shareReferralLink: 'مشاركة رابط الدعوة',
  referralLink: 'رابط الدعوة',
  generatingLink: 'جاري إنشاء الرابط...',
  email: 'البريد الإلكتروني: ',
  mobile: 'الجوال: ',
  purchasedPolicies: 'الوثائق المشتراة',
  activeQuotes: 'عروض الأسعار',
  pendingPolicies: 'الوثائق المٌشتراة الغير مٌصدرة',
  myBenefits: 'المزايا المُكتسبة',
  myProfessionInfo: 'بياناتي المهنية',
  active: 'مُفعلة',
  pending: 'الغير مٌصدرة',
  expired: 'منتهية',
  cancelled: 'ملغية',
  allPolicies: 'جميع الوثائق',
  noPoliciesFound: 'لم نتمكن من إيجاد وثائق',
  youCanStartBuying: 'يمكنك البدء في شراء وثيقة جديدة',
  buyNow: 'شراء وثيقة جديدة',
  purchaseNewPolicy: 'شراء وثيقة جديدة',
  noActiveQuotes: 'لم نتمكن من إيجاد تسعيرات قائمة',
  noActiveQuotesSubtitle: 'يمكنك البدء في مشاهدة عروض الأسعار',
  noPendingPolicies: 'لا توجد وثائق غير مصدرة',
  viewPolicy: 'عرض الوثيقة',
  paymentReceipt: 'إيصال الدفع',
  cancelPolicy: 'إلغاء الوثيقة',
  renewPolicy: 'تجديد الوثيقة',
  policyIssuanceInProgress: 'جاري العمل على إصدار الوثيقة',
  policyPrice: 'سعر الوثيقة',
  policyNumber: 'رقم الوثيقة',
  policyHolderId: 'هوية حامل الوثيقة',
  noBenefitsEarned: 'لا توجد مزايا مكتسبة حتى الآن',
  professionInfoHint: 'يمكنك تحديث بياناتك عند تجديد وثيقتك مع تأميني',
  qualification: 'المؤهلات الدراسية (العلمية)',
  performingSurgeries: 'هل تقوم بعمليات جراحية',
  experience: 'الخبرة',
  specialty: 'التخصص الطبي',
  placeOfPractice: 'مكان العمل',
  noSadadBills: 'لا توجد فواتير متاحة حاليا',
  noProfessionInfo: 'لا توجد معلومات مهنية متاحة',
  quoteTimeOut: 'سينقضي وقت التسعيرة خلال',
  viewQuote: 'عرض التسعيرة',
  failedToLoadQuotes: 'فشل تحميل التسعيرات',
  tryAgain: 'حاول مرة أخرى',
  subSpecialty: 'فرع التخصص الطبي',
  failedToLoadProfession: 'فشل تحميل المعلومات المهنية',
  failedToLoadBenefits: 'فشل تحميل المزايا',
} as const

export default dashboard
